/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1CourseregistrationEnrollmentManagementStatus202,
  PostApiV1CourseregistrationEnrollmentManagementStatus400,
  PostApiV1CourseregistrationEnrollmentManagementStatus401,
  PostApiV1CourseregistrationEnrollmentManagementStatus500,
  PostApiV1CourseregistrationEnrollmentManagementStatusMutationRequest,
  PostApiV1CourseregistrationEnrollmentManagementStatusMutationResponse,
} from "../../types/courseRegistrationEnrollmentController/PostApiV1CourseregistrationEnrollmentManagementStatus.ts";
import { courseRegistrationManagementOptionSaveViewModelSchema } from "../courseRegistrationManagementOptionSaveViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1CourseregistrationEnrollmentManagementStatus202Schema =
  z.any() as unknown as ToZod<PostApiV1CourseregistrationEnrollmentManagementStatus202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1CourseregistrationEnrollmentManagementStatus400Schema =
  z.any() as unknown as ToZod<PostApiV1CourseregistrationEnrollmentManagementStatus400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1CourseregistrationEnrollmentManagementStatus401Schema =
  z.any() as unknown as ToZod<PostApiV1CourseregistrationEnrollmentManagementStatus401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1CourseregistrationEnrollmentManagementStatus500Schema =
  z.any() as unknown as ToZod<PostApiV1CourseregistrationEnrollmentManagementStatus500>;

export const postApiV1CourseregistrationEnrollmentManagementStatusMutationRequestSchema =
  z.lazy(
    () => courseRegistrationManagementOptionSaveViewModelSchema,
  ) as unknown as ToZod<PostApiV1CourseregistrationEnrollmentManagementStatusMutationRequest>;

export const postApiV1CourseregistrationEnrollmentManagementStatusMutationResponseSchema =
  z.lazy(
    () => postApiV1CourseregistrationEnrollmentManagementStatus202Schema,
  ) as unknown as ToZod<PostApiV1CourseregistrationEnrollmentManagementStatusMutationResponse>;
